import { useHistory } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';

const Home = () => {
  const history = useHistory();
  const { oktaAuth, authState } = useOktaAuth();

  if (!authState) {
    return null;
  }

  const login = async () => history.push('/login');

  const logout = async () => {
    oktaAuth.signOut('/');
  };

  const UserLoggout = authState.isAuthenticated ? (
    <div href="#" onClick={() => logout()}>
      Signout
    </div>
  ) : (
    <div href="#" onClick={() => login()}>
      Signin
    </div>
  );

  return <div>{UserLoggout}</div>;
};
export default Home;
